import { StringStorage } from './StringStorage';

export class JsonStorage<T> {
  storate: StringStorage;

  constructor(
    private readonly key: string,
    private readonly assert = (_: T) => true
  ) {
    this.storate = new StringStorage(key);
  }

  getValue = (): T | null => {
    try {
      const s = this.getRawValue();
      if (s === null) return null;
      const ret = JSON.parse(s) as T;
      if (!this.assert(ret)) return null;
      return ret;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  setValue = (value: T): void => {
    try {
      const s = JSON.stringify(value);
      localStorage.setItem(this.key, s);
    } catch (e) {
      console.error(e);
    }
  };

  clearValue = (): void => {
    localStorage.removeItem(this.key);
  };

  getRawValue = (): string | null => {
    return this.storate.getValue();
  };
}
